import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  AfterViewChecked
} from '@angular/core';
import {FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Breakdown} from 'src/app/model/quote/breakdown/breakdown.model';
import {BreakdownService} from '../breakdown.service';
import {formatDate} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-breakdown-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css', '../../quote.component.css']
})
export class BreakdownDriversComponent implements OnInit, OnChanges, AfterViewChecked {

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private breakdownService: BreakdownService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar) {
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  get drivers(): FormArray {
    return this.formFields.get('drivers') as FormArray;
  }

  parentModelObj;
  showDrivers = false;
  isDriverNodeEmpty: boolean = null;

  @Input() staticData;
  @Input() selectedIndex;
  @Input() authDetails;
  formFields: any;
  submitted = false;
  @Input() modelObject;
  @Input() apiModelObject;
  @Output() modelObjectUpdated = new EventEmitter<Breakdown>();

  maxDOB: any = '';

  /*
* HELP TEXT POPUP
*/
  helptext = '';

  ngOnInit(): void {
    this.formFields = this.formBuilder.group({
      driver_conviction_declaration: ['', Validators.required],
      driver_claim_declaration: ['', Validators.required],
      drivers: this.formBuilder.array([]),
    });
    const currentDate = new Date();
    currentDate.setFullYear(new Date().getFullYear() - 16);

    this.maxDOB = currentDate.toISOString().slice(0, 10);
  }

  ngAfterViewChecked() {
    // your code to update the model
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.parentModelObj = this.modelObject;
    if (this.selectedIndex === 2 || this.selectedIndex === 3) {
      if (this.modelObject.drivers && this.modelObject.drivers.length > 0) {
        this.drivers.clear();
        this.modelObject.drivers.forEach((res) => {
          const driver = this.formBuilder.group({
            id: [res.id],
            title: [res.title],
            first_name: [res.first_name],
            last_name: [res.last_name],
            dob: [res.dob],
          });
          this.drivers.push(driver);
        });
      }
    }

    if (this.apiModelObject) {
      this.modelObject = this.apiModelObject.data.attributes.application;
      this.modelObject.id = this.apiModelObject.data.id;
      this.modelObject.reference = this.apiModelObject.data.attributes.reference;
      this.modelObject.status = this.apiModelObject.data.attributes.status;
      this.modelObject.sequence_number = this.apiModelObject.sequence_number;
      this.patchValues();
    }
  }

  addNewDriver() {
    this.isDriverNodeEmpty = false;
    this.drivers.push(this.initDrivers());
  }

  initDrivers() {
    return this.formBuilder.group({
      id: [''],
      title: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: [''],
      dob: ['', Validators.required],
      licence_type: ['', Validators.required],
      licence_length: ['', Validators.required],
      claims: [''],
      convictions: [''],
    });
  }

  patchValues() {
    this.formFields.patchValue({
      drivers: this.modelObject.drivers,
    });
  }

  viewDriversSection() {
    this.showDrivers = false;
    if (this.f.driver_conviction_declaration.value || this.f.driver_claim_declaration.value) {
      this.showDrivers = true;
    } else {
      if (this.modelObject.drivers && this.modelObject.drivers.length > 0) {
        this.showDrivers = true;
      }
    }
  }

  // addNewDriver() {
  //   this.isDriverNodeEmpty = false;
  //   this.drivers.push(this.initDrivers());
  // }

  removeDriver(index: number) {
    this.drivers.removeAt(index);
  }

  helpTextPopup(content, text) {
    this.modalService.open(content, {centered: true});
    this.helptext = text;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.formFields.valid) {
      return false;
    }
    const formData = this.formFields.value;
    this.modelObject.driver_conviction_declaration = formData.driver_conviction_declaration;
    this.modelObject.driver_claim_declaration = formData.driver_claim_declaration;
    this.modelObject.drivers = formData.drivers;
    if (this.modelObject.drivers && this.modelObject.drivers.length > 0) {
      this.isDriverNodeEmpty = false;
      this.modelObject.drivers.forEach((res) => {
        res.dob = formatDate(res.dob, 'yyyy-MM-dd', 'en-US');
        res.licence_length = formatDate(res.licence_length, 'yyyy-MM-dd', 'en-US');
        // Bind Claims
        if (res.claims.claims) {
          res.claims = res.claims.claims;
        }
        // Bind Claims
        if (res.convictions.convictions) {
          res.convictions = res.convictions.convictions;
        }

        if (this.modelObject.vehicles) {
          this.modelObject.vehicles.forEach((res1) => {
            const vehicleDrivers = res1.drivers.filter(x => x === res.id);
            if (vehicleDrivers.length === 0) {
              res1.drivers.push(res.id);
            }
          });
        }
      });


    } else {
      if (this.modelObject.driver_conviction_declaration || this.modelObject.driver_claim_declaration) {
        this.isDriverNodeEmpty = true;
        return;
      }
    }


    // GET UNIQUE ID FOR DRIVERS
    this.breakdownService.getUniqueID(this.authDetails)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.modelObject.drivers.forEach((res) => {
              if (!res.id) {
                res.id = response.meta.id;
              }
            });

            if (this.modelObject.type === 2) {
              this.modelObject.policy_id = null;
              this.modelObject.effective_date = null;
            }

            const data = {
              data: {
                type: this.modelObject.type,
                attributes: this.modelObject,
                // "id": (this.route.snapshot.params.id) ? this.route.snapshot.params.id : this.modelObj.id
                id: this.modelObject.id,
                broker_id: this.modelObject.broker_id,
                sequence_number: this.modelObject.sequence_number,
              }
            };
            this.breakdownService.saveQuote(data)
              .subscribe(
                (res: any) => {
                  if (res.success) {
                    if (res.result.quote_data && res.result.quote_data.quote_versions[0]) {
                      this.modelObject = res.result.quote_data.quote_versions[0].attributes.application;
                      this.modelObject.id = res.result.quote_data.quote_versions[0].id;
                      this.modelObject.broker_id = res.result.quote_data.quote_versions[0].broker_id;
                      this.modelObject.reference = res.result.quote_data.quote_versions[0].attributes.reference;
                      this.modelObject.status = res.result.quote_data.quote_versions[0].attributes.status;
                      this.modelObject.company_id = res.result.quote_data.quote_versions[0].company_id;
                      this.modelObject.is_send_email = res.result.quote_data.quote_versions[0].is_send_email;
                      this.modelObject.broker_commission = res.result.quote_data.quote_versions[0].financial_details.broker_commission;
                      this.modelObject.broker_admin_fee = res.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
                      this.modelObject.proposer.email = res.result.quote_data.quote_versions[0].policy_holder.email;
                      this.modelObject.proposer.phone = res.result.quote_data.quote_versions[0].policy_holder.phone;
                      this.modelObject.proposer.is_email = res.result.quote_data.quote_versions[0].policy_holder.is_email;
                      this.modelObject.proposer.is_phone = res.result.quote_data.quote_versions[0].policy_holder.is_phone;
                      this.modelObject.proposer.sms = res.result.quote_data.quote_versions[0].policy_holder.sms;
                      this.modelObject.proposer.post = res.result.quote_data.quote_versions[0].policy_holder.post;
                      if (res.result.quote_data.quote_versions[0].amlin_data.attributes.premium) {
                        this.modelObject.is_referred = res.result.quote_data.quote_versions[0].attributes.premium.referred;
                      }

                      this.modelObject.vehicles.forEach((res: { breakdown_cover: boolean; drivers: any[]; }) => {
                        res.breakdown_cover = false;  // changed 06-04-2023 - need to remove btreakdown
                        const drivers = [];
                        if (res.drivers && res.drivers.length > 0) {
                          res.drivers.forEach((d) => {
                            drivers.push(d);
                          });
                          res.drivers = drivers;
                        }

                      });
                      this.modelObjectUpdated.emit(this.modelObject);
                    }

                  } else {
                    this._snackBar.open(res.message, '', {
                      duration: 5000,
                      panelClass: 'text-danger'
                    });
                  }
                });
          }
        });


  }

}
